import huntingImage from '@/assets/hunting.avif';
import motorsportImage from '@/assets/motorsport_series.jpg';
import defaultImage from '@/assets/NACON.png';
import sessionImage from '@/assets/session.jpg';
import tduImage from '@/assets/TDUSC.png';

const gameImageMap: Record<string, string> = {
  hs3: huntingImage,
  ems: motorsportImage,
  session: sessionImage,
  tdusc: tduImage,
};

export const getGameImage = (gameCode: string): string => {
  return gameImageMap[gameCode.toLowerCase()] ?? defaultImage;
};
